<template>

        <v-container fluid v-if="emails" class="pa-5">

            <div class="d-flex align-center py-3">
                <div>
                    <div class="display-1">Emails</div>
                </div>
                <v-spacer></v-spacer>
                <v-btn
                        color="info"
                        dark
                        class="mb-2"
                        @click="createEmail"

                >
                    <i class="fas fa-plus mr-2"></i> New Email
                </v-btn>
            </div>

        <v-row>
            <v-col
                v-for="email in emails"
                :key="email.id"
                cols="4"
            >
                <v-card>
                    <v-card-title>{{email.title}}</v-card-title>
                    <v-card-actions>
                        <v-btn
                                :to="{name: 'email-view', params:{id: email.id}}"
                        >
                            <v-icon>mdi-pencil</v-icon>Edit
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
    import EMAILS_LIST from "../graphql/Emails/List.gql";
    import EMAILS_CREATE from "../graphql/Emails/Create.gql";

    export default {
        components:{
        },
        apollo: {
            emails: {
                query: EMAILS_LIST,
                variables() {},
                update: data => data.emails
            },
        },
        methods: {
            createEmail() {
                this.$apollo.mutate({
                    mutation: EMAILS_CREATE,
                    variables: {input: {title: 'New Email'}},
                }).then(() => {
                    this.$emit('complete')
                    this.updating = false
                    this.$emit('saved')
                    this.$store.dispatch('notification/addSuccess', 'Trainer created successful')
                    this.$apollo.queries.emails.refetch()
                }).catch((error) => {
                    this.$store.dispatch('notification/handleGraphQlError', error)
                })
            }
        },
    }
</script>

<style scoped>

    .unlayer-editor {
        height: 90%;
        width: 100%;
    }

</style>